<div class="container container-style section-gap"
  #chartContainer
  role="group"
  tabindex="0"
  [attr.aria-label]="(config?.chartAltText || (config?.title ? config.title + ' chart' : 'chart')) + '. Press Enter to navigate into chart'"
  (keydown)="onContainerKeydown($event)">
  <div class="d-flex justify-content-center align-items-center">
    <kla-title [lineConfig]="lineConfig" [config]="titleConfig" [showFooter]="false"></kla-title>
  </div>
  <div class="row">
    <div class="circle-charts-container">
      <div class="charts-container-line" *ngIf="showLineAcross"></div>
      <div class="charts-padding nav-item"
           *ngFor="let circleChart of config.circleCharts; index as i; even as isEven; let first = first; let last = last"
           [attr.tabindex]="focusedIndex === i ? 0 : -1"
           role="group"
           [attr.aria-label]="circleChart.title + ', ' + circleChart.subTitle + ', ' + circleChart.value"
           (focus)="focusedIndex = i"
           (keydown)="onItemKeydown($event, i)">
        <div class="charts-padding-after"
             *ngIf="showLineBetweenCircles"
             [class.first]="first"
             [class.last]="last"
             [style.background-color]='config.foregroundColor ||lineColor'>
        </div>
        <div class="circle-chart-title" [class.even]="isEven">
          <p class="first-line-texts">{{circleChart.title}} </p>
          <p class="second-line-texts">{{circleChart.subTitle}}</p>
        </div>
        <kla-simple-circle-chart
          [config]="generateConfig(circleChart.value, circleChart.circleText)"></kla-simple-circle-chart>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-10 offset-md-1 text-style">
      <app-dynamic-content
        [contentId]="'progressbar-circle-desc'"
        [htmlContent]="config.description">
      </app-dynamic-content>
    </div>
  </div>
  <div class="col-xs-10 offset-xs-1 col-sm-10 offset-sm-1 col-md-10 offset-md-1 col-lg-6 offset-lg-3 progressbar nav-item"
    [attr.tabindex]="focusedIndex === config.circleCharts.length ? 0 : -1"
    role="group"
    [attr.aria-label]="config?.progressChart?.title + ', ' + config?.progressChart?.subTitle + ', ' + config?.progressChart?.value"
    (focus)="focusedIndex = config.circleCharts.length"
    (keydown)="onItemKeydown($event, config.circleCharts.length)">
    <kla-simple-progressbar [value]="config.progressChart?.value" [color]="config.foregroundColor"></kla-simple-progressbar>
    <p class="progress-to-text">{{config.progressChart?.title}}</p>
    <p class="center-text font-style">{{config.progressChart?.subTitle}}</p>
  </div>
</div>
